module.exports = __webpack_public_path__ + "img/antes_despues_328.d293aa56.png";